import React, { useState } from 'react';
import { Col, Divider, Row } from 'antd';
import { Price } from '../Display';
import api from '../../utils/api';
import { AdditionalRequirementsProps } from '../../types/types';
import { DeleteOutlined } from '@ant-design/icons';

interface Props {
    quote_id?: number;
    editable?: boolean;
    loadQuote?: () => void;
    additional_requirements: AdditionalRequirementsProps[];
}

const AdditionalRequirements = ({ additional_requirements, quote_id, editable, loadQuote }: Props) => {
    const [loading, setLoading] = useState(false);

    const removeAdditionalRequirement = (application_cost_id: number) => {
        setLoading(true);
        api.requests
            .post(`/customer/quotes/${quote_id}/delete-additional-requirement/`, { id: application_cost_id })
            .then(() => {
                additional_requirements.filter(
                    additional_requirement => additional_requirement.id !== application_cost_id
                );
                setLoading(false);
            });
        if (loadQuote) loadQuote();
    };

    const content = additional_requirements.map(application_cost => {
        return (
            <div key={application_cost.id}>
                <Row>
                    <Col md={14}>
                        <div className={'text-left'}>
                            {application_cost.additional_requirement}
                        </div>
                    </Col>
                    <Col md={ editable ? 6 : 10}>
                        <Price value={application_cost.price} />
                    </Col>
                    {editable && (
                        <>
                            <Col md={4}>
                                <DeleteOutlined
                                    spin={loading}
                                    style={{ cursor: 'pointer', color: 'red' }}
                                    title={'Delete Requirement'}
                                    onClick={() => removeAdditionalRequirement(application_cost.id)}
                                />
                            </Col>
                        </>
                    )}
                </Row>
            </div>
        );
    });

    return (
        <>
            {additional_requirements.length > 0 && (
                <>
                    <div style={{ textAlign: 'right' }}>
                        <Divider>Additional Requirements</Divider>
                        {content}
                    </div>
                </>
            )}
        </>
    );
};

export default AdditionalRequirements;
